import { parentChains } from 'main/hotelBrandsAndChains'

export const MAX_DISCOUNT_PERCENTAGE = 70

export const nightsToStayOptions = {
  1: '1 night',
  2: '2 nights',
  3: '3 nights'
}

export function getPromoCodeWord(parentChainCode) {
  if (parentChainCode === parentChains.ihg || parentChainCode === parentChains.choice) {
    return 'rate code'
  }

  if (parentChainCode === parentChains.wyndham) {
    return 'corporate ID'
  }

  return 'promo code'
}

export function isPromotionCodeValid(promotionCode) {
  return Boolean(promotionCode?.match(/^[A-Za-z0-9]{1,15}$/gm))
}

export function clampDiscountPercentage(value) {
  if (value > MAX_DISCOUNT_PERCENTAGE) {
    return MAX_DISCOUNT_PERCENTAGE
  }

  if (value < 0) {
    return 0
  }

  return value
}
